export default __webpack_public_path__ + "static/SRUS P300 - Especification Del Producto y Datos Técnicos-99c833da5749ffd27c68d3e7cbb430f9.pdf";